import React, { useState } from "react";
import { useOutlet, useLocation, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import { db } from "../components/Firebase";
// import HtmlEditor from "../components/HtmlEditor";

const CreateNews = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  let { invokeModal, setCounter, counter } = useOutletContext();
  const onSubmit = () => {
    if (title && content) {
      db.collection("news")
        .add({
          title: title,
          content: content,
          date: Date.now(),
        })
        .then((i) => {
          setCounter((counter += 1));
          setContent("");
          setTitle("");
          invokeModal(false);
        });
    } else {
      return alert("please fill the form");
    }
  };

  return (
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-control-label">Title:</label>
              <input
                type="text"
                class="form-control"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </div>
            <div class="form-group">
              <label class="form-control-label">Content:</label>
              <textarea
                class="form-control"
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                }}
                multiple
              ></textarea>
            </div>

            <button class="btn btn-primary" onClick={onSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNews;
